var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.996C0 4.483 4.484 0 9.998 0 15.51 0 20 4.482 20 9.996 20 15.509 15.51 20 9.998 20 4.484 20 0 15.51 0 9.996zm18.333 0a8.319 8.319 0 00-8.335-8.33 8.314 8.314 0 00-8.331 8.33 8.32 8.32 0 008.33 8.335 8.324 8.324 0 008.336-8.335zm-8.329-4.86a.834.834 0 00-.837.831v5.076a.834.834 0 101.667 0V5.967a.834.834 0 00-.83-.832zm-.8 7.98a1.125 1.125 0 111.59 1.59 1.125 1.125 0 01-1.59-1.59z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.8e9994d7614922417ac1479db362937a.svg";
export { ForwardRef as ReactComponent };